module.exports = __webpack_public_path__ + "static/media/isotipo-kalenis-ilust.e90997c1.svg";